export type BirthCountry = {
  name: string;
  flag: string;
  cities: string[];
};

export const BIRTH_COUNTRIES: BirthCountry[] = [
  {
    name: "Congo-Brazzaville", flag: "🇨🇬",
    cities: [
      "Brazzaville", "Pointe-Noire", "Dolisie", "Nkayi", "Ouesso", "Owando", "Impfondo",
      "Madingou", "Sibiti", "Kinkala", "Mossendjo", "Gamboma", "Djambala", "Ewo", "Loutété",
      "Boundji", "Makoua", "Oyo", "Zanaga", "Kindamba", "Mindouli", "Boko", "Ngabé",
      "Loudima", "Kayes (Congo)", "Mouyondzi", "Komono", "Souanké", "Sembé", "Dongou",
      "Épéna", "Betou", "Pikounda", "Kellé", "Mbomo", "Abala", "Ollombo", "Mpouya",
      "Ongogni", "Makabana", "Mila-Mila", "Tchikapika", "Ngoko", "Itoumbi", "Lékana",
    ],
  },
  {
    name: "Congo-Kinshasa", flag: "🇨🇩",
    cities: [
      "Kinshasa", "Lubumbashi", "Mbuji-Mayi", "Kisangani", "Kananga", "Bukavu", "Goma",
      "Likasi", "Kolwezi", "Matadi", "Tshikapa", "Mbandaka", "Butembo", "Kikwit", "Uvira",
      "Beni", "Mwene-Ditu", "Isiro", "Kindu", "Kalemie", "Bunia", "Gemena", "Bandundu",
      "Ilebo", "Gbadolite", "Bumba", "Boma", "Lodja", "Kipushi", "Lisala", "Kamina",
      "Inongo", "Boende", "Kabinda", "Fungurume", "Mahagi", "Watsa", "Kasongo",
    ],
  },
  {
    name: "France", flag: "🇫🇷",
    cities: [
      "Paris", "Marseille", "Lyon", "Toulouse", "Nice", "Nantes", "Strasbourg",
      "Montpellier", "Bordeaux", "Lille", "Rennes", "Reims", "Saint-Étienne", "Le Havre",
      "Toulon", "Grenoble", "Dijon", "Angers", "Nîmes", "Villeurbanne", "Clermont-Ferrand",
      "Le Mans", "Aix-en-Provence", "Brest", "Tours", "Amiens", "Limoges", "Perpignan",
      "Metz", "Besançon", "Orléans", "Rouen", "Mulhouse", "Caen", "Nancy", "Argenteuil",
      "Montreuil", "Saint-Denis", "Avignon", "Versailles", "Poitiers", "La Rochelle",
      "Pau", "Calais", "Cannes", "Antibes", "Béziers", "Dunkerque", "Ajaccio", "Bastia",
      "Cayenne", "Fort-de-France", "Pointe-à-Pitre", "Saint-Pierre (Réunion)",
    ],
  },
  {
    name: "Cameroun", flag: "🇨🇲",
    cities: [
      "Yaoundé", "Douala", "Bamenda", "Bafoussam", "Garoua", "Maroua", "Ngaoundéré",
      "Bertoua", "Kribi", "Limbé", "Kumba", "Buéa", "Edéa", "Nkongsamba", "Ebolowa",
      "Dschang", "Foumban", "Sangmélima", "Kumbo", "Meiganga", "Guider", "Tiko",
      "Mokolo", "Mbalmayo", "Bangangté", "Mbouda", "Loum", "Mamfe", "Obala",
      "Yabassi", "Tcholliré", "Mora", "Penja", "Bafang", "Fundong", "Wum",
    ],
  },
  {
    name: "Gabon", flag: "🇬🇦",
    cities: [
      "Libreville", "Port-Gentil", "Franceville", "Oyem", "Moanda", "Mouila",
      "Lambaréné", "Tchibanga", "Koulamoutou", "Makokou", "Bitam", "Gamba",
      "Lastoursville", "Ntoum", "Okondja", "Mékambo", "Ndendé", "Fougamou",
      "Booué", "Lékoni", "Mayumba", "Omboué", "Mitzic", "Ndjolé", "Minvoul",
    ],
  },
  {
    name: "Sénégal", flag: "🇸🇳",
    cities: [
      "Dakar", "Thiès", "Saint-Louis", "Kaolack", "Ziguinchor", "Touba", "Rufisque",
      "Mbour", "Diourbel", "Tambacounda", "Kolda", "Kédougou", "Louga", "Matam",
      "Fatick", "Sédhiou", "Kaffrine", "Richard-Toll", "Pikine", "Guédiawaye",
      "Tivaouane", "Joal-Fadiouth", "Saly", "Nioro du Rip", "Bignona",
    ],
  },
  {
    name: "Côte d'Ivoire", flag: "🇨🇮",
    cities: [
      "Abidjan", "Bouaké", "Yamoussoukro", "Korhogo", "Daloa", "San-Pédro", "Man",
      "Gagnoa", "Divo", "Anyama", "Abengourou", "Soubré", "Séguéla", "Bondoukou",
      "Odienné", "Danané", "Ferkessédougou", "Adzopé", "Agboville", "Grand-Bassam",
      "Bingerville", "Issia", "Sinfra", "Guiglo", "Duékoué", "Sassandra", "Katiola",
    ],
  },
  {
    name: "Mali", flag: "🇲🇱",
    cities: [
      "Bamako", "Sikasso", "Mopti", "Koutiala", "Ségou", "Kayes", "Gao", "Tombouctou",
      "Kidal", "Koulikoro", "San", "Niono", "Kati", "Kolokani", "Bougouni", "Djenné",
      "Bandiagara", "Nioro du Sahel", "Douentza", "Ménaka",
    ],
  },
  {
    name: "Guinée", flag: "🇬🇳",
    cities: [
      "Conakry", "Nzérékoré", "Kankan", "Kindia", "Labé", "Mamou", "Siguiri",
      "Kissidougou", "Guéckédou", "Boké", "Dubréka", "Faranah", "Coyah",
      "Dalaba", "Télimélé", "Pita", "Macenta", "Fria", "Kamsar",
    ],
  },
  {
    name: "Burkina Faso", flag: "🇧🇫",
    cities: [
      "Ouagadougou", "Bobo-Dioulasso", "Koudougou", "Banfora", "Ouahigouya",
      "Kaya", "Tenkodogo", "Fada N'Gourma", "Dédougou", "Pouytenga", "Houndé",
      "Ziniaré", "Manga", "Kongoussi", "Réo", "Garango", "Djibo",
    ],
  },
  {
    name: "Togo", flag: "🇹🇬",
    cities: [
      "Lomé", "Sokodé", "Kara", "Kpalimé", "Atakpamé", "Bassar", "Tsévié",
      "Aného", "Dapaong", "Mango", "Notsé", "Tabligbo", "Vogan", "Badou",
    ],
  },
  {
    name: "Bénin", flag: "🇧🇯",
    cities: [
      "Cotonou", "Porto-Novo", "Parakou", "Abomey-Calavi", "Djougou", "Bohicon",
      "Natitingou", "Kandi", "Lokossa", "Ouidah", "Abomey", "Savè",
      "Comè", "Malanville", "Nikki", "Tchaourou", "Savalou",
    ],
  },
  {
    name: "Tchad", flag: "🇹🇩",
    cities: [
      "N'Djamena", "Moundou", "Sarh", "Abéché", "Kélo", "Koumra", "Bongor",
      "Mongo", "Doba", "Pala", "Am Timan", "Faya-Largeau", "Laï", "Moussoro",
      "Biltine", "Ati", "Massaguet", "Bol",
    ],
  },
  {
    name: "Niger", flag: "🇳🇪",
    cities: [
      "Niamey", "Zinder", "Maradi", "Agadez", "Tahoua", "Dosso", "Diffa",
      "Arlit", "Tessaoua", "Birni N'Konni", "Tillabéri", "Filingué", "Mirriah",
      "Madaoua", "Gaya", "Nguigmi", "Mayahi",
    ],
  },
  {
    name: "Madagascar", flag: "🇲🇬",
    cities: [
      "Antananarivo", "Toamasina", "Antsirabe", "Fianarantsoa", "Mahajanga",
      "Toliara", "Antsiranana", "Ambovombe", "Mananjary", "Antsirabe II",
      "Ambanja", "Ambatondrazaka", "Morondava", "Nosy Be", "Sainte-Marie",
      "Manakara", "Farafangana", "Moramanga",
    ],
  },
  {
    name: "Belgique", flag: "🇧🇪",
    cities: [
      "Bruxelles", "Anvers", "Liège", "Gand", "Charleroi", "Namur", "Bruges",
      "Mons", "Louvain", "Tournai", "Hasselt", "Arlon", "Courtrai", "Ostende",
      "Verviers", "Malines", "La Louvière", "Mouscron", "Seraing",
    ],
  },
  {
    name: "Canada", flag: "🇨🇦",
    cities: [
      "Montréal", "Toronto", "Ottawa", "Québec", "Vancouver", "Calgary", "Edmonton",
      "Winnipeg", "Halifax", "Gatineau", "Laval", "Longueuil", "Sherbrooke",
      "Trois-Rivières", "Saguenay", "Lévis", "Moncton", "Regina", "Saskatoon",
    ],
  },
  {
    name: "Suisse", flag: "🇨🇭",
    cities: [
      "Genève", "Zurich", "Berne", "Lausanne", "Bâle", "Lucerne", "Lugano",
      "Fribourg", "Neuchâtel", "Sion", "Winterthour", "Bienne", "Thoune",
      "La Chaux-de-Fonds", "Montreux", "Yverdon-les-Bains",
    ],
  },
  {
    name: "Centrafrique", flag: "🇨🇫",
    cities: [
      "Bangui", "Bimbo", "Berbérati", "Carnot", "Bambari", "Bouar", "Bossangoa",
      "Bria", "Bangassou", "Nola", "Kaga-Bandoro", "Mbaïki", "Ndélé", "Sibut",
      "Damara", "Bozoum", "Batangafo", "Zemio",
    ],
  },
  {
    name: "Rwanda", flag: "🇷🇼",
    cities: [
      "Kigali", "Butare (Huye)", "Gitarama (Muhanga)", "Gisenyi (Rubavu)",
      "Ruhengeri (Musanze)", "Byumba (Gicumbi)", "Cyangugu (Rusizi)",
      "Kibungo (Ngoma)", "Kibuye (Karongi)", "Nyanza",
    ],
  },
  {
    name: "Burundi", flag: "🇧🇮",
    cities: [
      "Bujumbura", "Gitega", "Ngozi", "Rumonge", "Muyinga", "Ruyigi",
      "Kayanza", "Makamba", "Bururi", "Cibitoke", "Bubanza", "Muramvya",
    ],
  },
  {
    name: "Djibouti", flag: "🇩🇯",
    cities: [
      "Djibouti", "Ali Sabieh", "Dikhil", "Tadjourah", "Obock", "Arta",
    ],
  },
  {
    name: "Comores", flag: "🇰🇲",
    cities: [
      "Moroni", "Mutsamudu", "Fomboni", "Domoni", "Mitsamiouli", "Mbéni",
    ],
  },
  {
    name: "Maurice", flag: "🇲🇺",
    cities: [
      "Port-Louis", "Curepipe", "Vacoas-Phoenix", "Quatre Bornes",
      "Beau-Bassin Rose-Hill", "Mahébourg", "Tamarin", "Flic en Flac",
    ],
  },
  {
    name: "Haïti", flag: "🇭🇹",
    cities: [
      "Port-au-Prince", "Cap-Haïtien", "Gonaïves", "Les Cayes", "Pétion-Ville",
      "Delmas", "Jacmel", "Jérémie", "Hinche", "Port-de-Paix", "Miragoâne",
    ],
  },
  {
    name: "Tunisie", flag: "🇹🇳",
    cities: [
      "Tunis", "Sfax", "Sousse", "Kairouan", "Bizerte", "Gabès", "Ariana",
      "Monastir", "Ben Arous", "Nabeul", "Médenine", "Kasserine", "Tozeur",
      "Hammamet", "Djerba", "Mahdia", "Béja", "Jendouba", "Tataouine",
    ],
  },
  {
    name: "Maroc", flag: "🇲🇦",
    cities: [
      "Casablanca", "Rabat", "Fès", "Marrakech", "Tanger", "Agadir", "Meknès",
      "Oujda", "Kénitra", "Tétouan", "Salé", "Nador", "Mohammedia", "El Jadida",
      "Béni Mellal", "Khouribga", "Taza", "Essaouira", "Ifrane", "Ouarzazate",
      "Laâyoune", "Dakhla", "Chefchaouen", "Safi",
    ],
  },
  {
    name: "Algérie", flag: "🇩🇿",
    cities: [
      "Alger", "Oran", "Constantine", "Annaba", "Blida", "Batna", "Sétif",
      "Djelfa", "Biskra", "Tlemcen", "Béjaïa", "Tizi Ouzou", "Skikda",
      "Sidi Bel Abbès", "Chlef", "Mostaganem", "Ghardaïa", "Tamanrasset",
      "Bordj Bou Arréridj", "Jijel", "Médéa", "M'sila", "Ouargla",
    ],
  },
  {
    name: "Mauritanie", flag: "🇲🇷",
    cities: [
      "Nouakchott", "Nouadhibou", "Kiffa", "Kaédi", "Rosso", "Zouérat",
      "Atar", "Néma", "Aleg", "Tidjikja", "Sélibaby", "Aioun el Atrouss",
    ],
  },
  {
    name: "Guinée équatoriale", flag: "🇬🇶",
    cities: [
      "Malabo", "Bata", "Ebebiyín", "Aconibe", "Añisoc", "Luba", "Evinayong",
      "Mongomo", "Riaba",
    ],
  },
  {
    name: "Guinée-Bissau", flag: "🇬🇼",
    cities: [
      "Bissau", "Bafatá", "Gabú", "Bissorã", "Bolama", "Cacheu", "Catió",
      "Mansôa", "Farim",
    ],
  },
  {
    name: "Cap-Vert", flag: "🇨🇻",
    cities: ["Praia", "Mindelo", "Espargos", "Assomada", "Santa Maria"],
  },
  {
    name: "São Tomé-et-Príncipe", flag: "🇸🇹",
    cities: ["São Tomé", "Santo Amaro", "Neves", "Trindade", "Guadalupe"],
  },
  {
    name: "Seychelles", flag: "🇸🇨",
    cities: ["Victoria", "Anse Boileau", "Beau Vallon", "Takamaka"],
  },
  // Non-francophone but commonly selected
  {
    name: "Nigeria", flag: "🇳🇬",
    cities: [
      "Lagos", "Abuja", "Kano", "Ibadan", "Port Harcourt", "Benin City",
      "Kaduna", "Enugu", "Calabar", "Warri", "Owerri", "Uyo", "Jos",
    ],
  },
  {
    name: "Ghana", flag: "🇬🇭",
    cities: [
      "Accra", "Kumasi", "Tamale", "Takoradi", "Cape Coast", "Tema", "Sunyani",
      "Ho", "Koforidua", "Bolgatanga",
    ],
  },
  {
    name: "Afrique du Sud", flag: "🇿🇦",
    cities: [
      "Johannesburg", "Le Cap", "Durban", "Pretoria", "Port Elizabeth",
      "Bloemfontein", "Soweto", "Pietermaritzburg", "East London",
    ],
  },
  {
    name: "Angola", flag: "🇦🇴",
    cities: [
      "Luanda", "Huambo", "Lobito", "Benguela", "Lubango", "Cabinda",
      "Malanje", "Namibe", "Uíge", "Soyo",
    ],
  },
  {
    name: "Mozambique", flag: "🇲🇿",
    cities: [
      "Maputo", "Beira", "Nampula", "Quelimane", "Chimoio", "Tete",
      "Nacala", "Lichinga", "Pemba",
    ],
  },
  {
    name: "Éthiopie", flag: "🇪🇹",
    cities: [
      "Addis-Abeba", "Dire Dawa", "Gondar", "Mekelle", "Bahir Dar",
      "Hawassa", "Adama", "Jimma", "Dessie", "Harar",
    ],
  },
  {
    name: "Kenya", flag: "🇰🇪",
    cities: [
      "Nairobi", "Mombasa", "Kisumu", "Nakuru", "Eldoret", "Thika",
      "Malindi", "Lamu", "Nyeri", "Machakos",
    ],
  },
  {
    name: "Tanzanie", flag: "🇹🇿",
    cities: [
      "Dar es Salaam", "Dodoma", "Mwanza", "Arusha", "Zanzibar",
      "Mbeya", "Morogoro", "Tanga", "Kigoma",
    ],
  },
  {
    name: "Ouganda", flag: "🇺🇬",
    cities: [
      "Kampala", "Entebbe", "Gulu", "Lira", "Mbarara", "Jinja",
      "Fort Portal", "Mbale", "Masaka", "Arua",
    ],
  },
  {
    name: "Égypte", flag: "🇪🇬",
    cities: [
      "Le Caire", "Alexandrie", "Gizeh", "Louxor", "Assouan", "Port-Saïd",
      "Suez", "Charm el-Cheikh", "Hurghada", "Tanta", "Mansourah",
    ],
  },
  {
    name: "Liban", flag: "🇱🇧",
    cities: [
      "Beyrouth", "Tripoli", "Sidon", "Jounieh", "Zahlé", "Baalbek",
      "Byblos", "Tyr", "Nabatieh",
    ],
  },
  {
    name: "États-Unis", flag: "🇺🇸",
    cities: [
      "New York", "Los Angeles", "Chicago", "Houston", "Phoenix", "Miami",
      "Washington D.C.", "San Francisco", "Boston", "Seattle", "Dallas",
      "Atlanta", "Denver", "Detroit", "Minneapolis", "Philadelphie",
    ],
  },
  {
    name: "Royaume-Uni", flag: "🇬🇧",
    cities: [
      "Londres", "Manchester", "Birmingham", "Liverpool", "Glasgow",
      "Édimbourg", "Bristol", "Leeds", "Cardiff", "Belfast", "Oxford",
      "Cambridge",
    ],
  },
  {
    name: "Allemagne", flag: "🇩🇪",
    cities: [
      "Berlin", "Munich", "Hambourg", "Francfort", "Cologne", "Stuttgart",
      "Düsseldorf", "Dortmund", "Essen", "Leipzig", "Dresde", "Hanovre",
      "Nuremberg", "Brême",
    ],
  },
  {
    name: "Espagne", flag: "🇪🇸",
    cities: [
      "Madrid", "Barcelone", "Valence", "Séville", "Saragosse", "Malaga",
      "Bilbao", "Grenade", "Palma de Majorque", "Las Palmas",
    ],
  },
  {
    name: "Italie", flag: "🇮🇹",
    cities: [
      "Rome", "Milan", "Naples", "Turin", "Florence", "Bologne", "Gênes",
      "Venise", "Palerme", "Bari", "Catane",
    ],
  },
  {
    name: "Portugal", flag: "🇵🇹",
    cities: [
      "Lisbonne", "Porto", "Braga", "Coimbra", "Faro", "Funchal", "Évora",
      "Setúbal", "Aveiro",
    ],
  },
  {
    name: "Brésil", flag: "🇧🇷",
    cities: [
      "São Paulo", "Rio de Janeiro", "Brasília", "Salvador", "Fortaleza",
      "Belo Horizonte", "Manaus", "Curitiba", "Recife", "Belém",
    ],
  },
  {
    name: "Chine", flag: "🇨🇳",
    cities: [
      "Pékin", "Shanghai", "Canton", "Shenzhen", "Chengdu", "Wuhan",
      "Chongqing", "Hangzhou", "Nanjing", "Xi'an", "Tianjin",
    ],
  },
  {
    name: "Inde", flag: "🇮🇳",
    cities: [
      "New Delhi", "Mumbai", "Bangalore", "Hyderabad", "Chennai", "Kolkata",
      "Pune", "Ahmedabad", "Jaipur", "Lucknow",
    ],
  },
  {
    name: "Turquie", flag: "🇹🇷",
    cities: [
      "Istanbul", "Ankara", "Izmir", "Antalya", "Bursa", "Adana",
      "Gaziantep", "Konya", "Mersin", "Diyarbakır",
    ],
  },
  {
    name: "Russie", flag: "🇷🇺",
    cities: [
      "Moscou", "Saint-Pétersbourg", "Novossibirsk", "Iekaterinbourg",
      "Kazan", "Nijni Novgorod", "Samara", "Rostov-sur-le-Don", "Krasnodar",
    ],
  },
  {
    name: "Japon", flag: "🇯🇵",
    cities: [
      "Tokyo", "Osaka", "Kyoto", "Yokohama", "Nagoya", "Sapporo",
      "Kobe", "Fukuoka", "Hiroshima", "Sendai",
    ],
  },
  {
    name: "Corée du Sud", flag: "🇰🇷",
    cities: [
      "Séoul", "Busan", "Incheon", "Daegu", "Daejeon", "Gwangju",
      "Suwon", "Ulsan", "Jeju",
    ],
  },
  {
    name: "Arabie saoudite", flag: "🇸🇦",
    cities: [
      "Riyad", "Djeddah", "La Mecque", "Médine", "Dammam", "Khobar",
      "Tabouk", "Abha",
    ],
  },
  {
    name: "Émirats arabes unis", flag: "🇦🇪",
    cities: [
      "Dubaï", "Abou Dabi", "Charjah", "Al-Aïn", "Ajman", "Ras el-Khaïmah",
      "Fujaïrah",
    ],
  },
  {
    name: "Australie", flag: "🇦🇺",
    cities: [
      "Sydney", "Melbourne", "Brisbane", "Perth", "Adélaïde", "Canberra",
      "Hobart", "Darwin", "Gold Coast",
    ],
  },
  {
    name: "Mexique", flag: "🇲🇽",
    cities: [
      "Mexico", "Guadalajara", "Monterrey", "Puebla", "Tijuana", "Cancún",
      "Mérida", "Querétaro", "León", "Oaxaca",
    ],
  },
  {
    name: "Argentine", flag: "🇦🇷",
    cities: [
      "Buenos Aires", "Córdoba", "Rosario", "Mendoza", "La Plata",
      "Tucumán", "Mar del Plata", "Salta", "Bariloche",
    ],
  },
  {
    name: "Colombie", flag: "🇨🇴",
    cities: [
      "Bogota", "Medellín", "Cali", "Barranquilla", "Carthagène",
      "Bucaramanga", "Pereira", "Santa Marta", "Manizales",
    ],
  },
];

/** Flat list of all cities with country info for search */
export type CityEntry = { city: string; country: string; flag: string };

let _flatCities: CityEntry[] | null = null;

export function getAllCities(): CityEntry[] {
  if (_flatCities) return _flatCities;
  _flatCities = [];
  for (const c of BIRTH_COUNTRIES) {
    for (const city of c.cities) {
      _flatCities.push({ city, country: c.name, flag: c.flag });
    }
  }
  return _flatCities;
}

/** Simple fuzzy/prefix matching — strips accents and compares */
function normalize(s: string): string {
  return s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
}

export function searchCities(query: string, limit = 30): CityEntry[] {
  if (!query.trim()) return [];
  const all = getAllCities();
  const q = normalize(query);
  const tokens = q.split(/\s+/).filter(Boolean);

  // Score each entry
  const scored: { entry: CityEntry; score: number }[] = [];
  for (const entry of all) {
    const nc = normalize(entry.city);
    const nco = normalize(entry.country);

    let score = 0;
    let allMatch = true;
    for (const token of tokens) {
      if (nc.startsWith(token)) {
        score += 100;
      } else if (nc.includes(token)) {
        score += 60;
      } else if (nco.startsWith(token)) {
        score += 40;
      } else if (nco.includes(token)) {
        score += 20;
      } else {
        // Fuzzy: check Levenshtein-like match for short tokens
        if (token.length >= 3 && fuzzyMatch(nc, token)) {
          score += 30;
        } else if (token.length >= 3 && fuzzyMatch(nco, token)) {
          score += 15;
        } else {
          allMatch = false;
        }
      }
    }

    if (allMatch && score > 0) {
      scored.push({ entry, score });
    }
  }

  scored.sort((a, b) => b.score - a.score);
  return scored.slice(0, limit).map((s) => s.entry);
}

/** Simple fuzzy match: allow 1-2 character differences */
function fuzzyMatch(haystack: string, needle: string): boolean {
  // Sliding window approach
  if (needle.length > haystack.length + 2) return false;
  for (let i = 0; i <= haystack.length - needle.length + 1; i++) {
    let diff = 0;
    for (let j = 0; j < needle.length && i + j < haystack.length; j++) {
      if (haystack[i + j] !== needle[j]) diff++;
      if (diff > 1) break;
    }
    if (diff <= 1) return true;
  }
  return false;
}

/** Popular cities shown by default */
export const POPULAR_CITIES: CityEntry[] = [
  { city: "Brazzaville", country: "Congo-Brazzaville", flag: "🇨🇬" },
  { city: "Pointe-Noire", country: "Congo-Brazzaville", flag: "🇨🇬" },
  { city: "Kinshasa", country: "Congo-Kinshasa", flag: "🇨🇩" },
  { city: "Paris", country: "France", flag: "🇫🇷" },
  { city: "Douala", country: "Cameroun", flag: "🇨🇲" },
  { city: "Dakar", country: "Sénégal", flag: "🇸🇳" },
  { city: "Abidjan", country: "Côte d'Ivoire", flag: "🇨🇮" },
  { city: "Libreville", country: "Gabon", flag: "🇬🇦" },
  { city: "Yaoundé", country: "Cameroun", flag: "🇨🇲" },
  { city: "Bamako", country: "Mali", flag: "🇲🇱" },
  { city: "Conakry", country: "Guinée", flag: "🇬🇳" },
  { city: "Lomé", country: "Togo", flag: "🇹🇬" },
];
